"use client";
import { useEffect } from "react";
import { IPackages, IUserPackage } from "@/interfaces";
import { usePackages } from "@/context/packagesContext";

export default function PackagesHydrator({
  packages,
  user,
}: {
  packages: IPackages[];
  user?: IUserPackage[];
}) {
  const { setPackages, setUser } = usePackages();
  useEffect(() => {
    if (Array.isArray(packages) && packages.length > 0) {
      setPackages(packages);
    }
    if (user !== undefined) {
      setUser(user);
    }
  }, [packages, user, setPackages, setUser]);
  return null;
}
